import { Create } from "@mui/icons-material"
import { Datagrid, Edit, EditButton, List, ReferenceField, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField,downloadCSV } from "react-admin"
import jsonExport from 'jsonexport/dist';

const SERVICE = 'requests'

const exporter = (records, fetchRelatedRecords) => {
    // will call dataProvider.getMany('posts', { ids: records.map(record => record.post_id) }), ignoring duplicate and empty post_id
    fetchRelatedRecords(records, 'event', 'events').then(events => {
        const data = records.map(record => ({
                ...record,
                event: events[record.event].label,
        }));
        return jsonExport(data, {
        }, (err, csv) => {
            downloadCSV(csv, 'requests');
        });
    });
};

const RequestsList = () => {
    return (
        <List exporter={exporter}>
            <Datagrid>
                <ReferenceField source="event" reference="events">
                    <TextField source="label" />
                </ReferenceField>
                <TextField source="email" />
                <EditButton />
                <ShowButton />
            </Datagrid>
        </List>
    )
}

const RequestCreate = () => {
    return (
        <Create>
            <SimpleForm>

            </SimpleForm>
        </Create>
    )
}

const RequestEdit = () => {
    return (
        <Edit>
            <SimpleForm>

            </SimpleForm>
        </Edit>
    )
}

const RequestShow = () => {
    return (
        <Show>
            <SimpleShowLayout>
                <ReferenceField source="event" reference="events">
                    <TextField source="label" />
                </ReferenceField>
                <TextField source="email" />
                <TextField source="phone" />
                <TextField source="fio" />
                <TextField source="experience" />
            </SimpleShowLayout>
        </Show>
    )
}

export const requestProps = {
    name: SERVICE,
    list: RequestsList,
    create: RequestCreate,
    edit: RequestEdit,
    show: RequestShow
}